import { render, staticRenderFns } from "./SpecialWelcomeMessage.vue?vue&type=template&id=2bc8b2a0&"
import script from "./SpecialWelcomeMessage.vue?vue&type=script&lang=js&"
export * from "./SpecialWelcomeMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports